"use client";

import { useState } from "react";
import { Menu } from "lucide-react";
import {
  Button,
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
} from "@stocks/ui";

import { SidebarNav } from "./SidebarNav";

const Brand = () => (
  <div className='flex h-14 items-center border-b px-6 text-lg font-semibold'>
    Stocks
  </div>
);

/**
 * 사이드바. 데스크톱(md↑)은 고정 사이드바, 모바일은 상단바 + 햄버거 Sheet.
 */
export const Sidebar = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <aside className='hidden w-60 shrink-0 border-r bg-background md:block'>
        <Brand />
        <SidebarNav />
      </aside>

      <header className='sticky top-0 z-30 flex h-14 items-center gap-2 border-b bg-background px-4 md:hidden'>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button variant='ghost' size='icon' aria-label='메뉴 열기'>
              <Menu className='size-5' />
            </Button>
          </SheetTrigger>
          <SheetContent side='left' className='w-64 p-0'>
            <SheetTitle className='sr-only'>메뉴</SheetTitle>
            <SheetDescription className='sr-only'>
              페이지 이동 메뉴
            </SheetDescription>
            <Brand />
            <SidebarNav onNavigate={() => setOpen(false)} />
          </SheetContent>
        </Sheet>
        <span className='font-semibold'>Stocks</span>
      </header>
    </>
  );
};
